export default __webpack_public_path__ + "static/media/NextPagination.8d1cba6a.svg";